// add some helpful calculated attributes to people so we can display
// them better in the UI

import Firebase from 'firebase/app'
import Moment from 'moment'

import intervalChoiceUnits from '../views/misc/intervalChoiceUnits'

const classifyPerson = person => {
  
  let intervalString, nextTouch, nextScheduledTouch = undefined
  let showAsLate, showAsReady, showAsUpcoming, showAsSnoozed, showAsNeedsInfo = undefined
  let hasInterval = person.interval && person.interval.value && person.interval.unit

  if (!person._lastTouchDate || !hasInterval) {
    showAsNeedsInfo = true
  } else {

    // DATES
    const intervalUnit = intervalChoiceUnits.find(choice => choice.id === person.interval.unit)
    const intervalUnitString = person.interval.value === 1 ? intervalUnit.nameSingular : intervalUnit.namePlural
    const intervalValueString = person.interval.value === 1 ? '' : person.interval.value+' '
    intervalString = 'every '+intervalValueString+' '+intervalUnitString

    // dates/durations in milliseconds
    const nowM = Firebase.firestore.Timestamp.now().toMillis()
    const snoozeDateM = person.snoozedUntil ? person.snoozedUntil.toMillis() : 0
    const lastTouchDateM = person._lastTouchDate ? person._lastTouchDate.toMillis() : 0
    const intervalM = person.interval.value * intervalUnit.dayValue * 24*60*60*1000

    const nextScheduledTouchM = lastTouchDateM + intervalM
    const nextTouchM = nextScheduledTouchM > snoozeDateM ? nextScheduledTouchM : snoozeDateM
    const lateThresholdM = 3 * intervalUnit.dayValue*24*60*60*1000 // depends on interval

    nextTouch = Moment(nextTouchM).toDate()
    nextScheduledTouch = Moment(nextScheduledTouchM).toDate()

    // FLAGS

    // these two are mutually-exclusive (with showAsNeedsInfo)
    showAsReady = nowM > nextTouchM
    showAsUpcoming = nowM <= nextTouchM

    // these are bonus attrs added to either ready or upcoming people
    showAsLate = nowM > nextTouchM + lateThresholdM
    showAsSnoozed = showAsUpcoming && snoozeDateM > nowM && snoozeDateM > nextScheduledTouchM
  }

  return {
    intervalString,
    nextTouch,
    nextScheduledTouch,
    showAsNeedsInfo,
    showAsReady,
    showAsUpcoming,
    showAsLate,
    showAsSnoozed,
    ...person,
  }
}

export default classifyPerson



// WEBPACK FOOTER //
// ./src/actions/classifyPerson.js